export const PREVIEW_INVENTORY = [
  { value: 'current', label: 'Current inventory' },
  { value: 'empty', label: 'No games' },
  { value: 'unavailable_markets', label: 'Markets unavailable' },
  { value: 'unavailable_inventory', label: 'Inventory unavailable' },
]

export function previewInventoryMessage(mode) {
  return mode === 'empty' ? 'No matching games' : mode === 'unavailable_inventory' ? 'Games are unavailable. Try again shortly.' : null
}

// Apply after retrieval. A rehearsal never rewrites query caches, draft content,
// account following, publication state or a provider response.
export function projectPreviewInventory(catalog, mode = 'current') {
  if (!PREVIEW_INVENTORY.some((choice) => choice.value === mode)) throw new Error('Unsupported inventory rehearsal')
  if (mode === 'current') return catalog
  const events = (source) => mode === 'unavailable_markets' ? source.map((event) => ({ ...event,
    markets: event.markets.map((market) => ({ ...market, status: 'SUSPENDED', outcomes: market.outcomes.map((outcome) => ({ ...outcome, status: 'SUSPENDED', odds: null })) })),
  })) : []
  const collection_results = Object.fromEntries(Object.entries(catalog.collection_results || {}).map(([id, result]) => [id, { ...result,
    state: mode === 'empty' ? 'empty' : mode === 'unavailable_inventory' ? 'unavailable' : result.state,
    complete: mode === 'empty' || mode !== 'unavailable_inventory' && result.complete,
    scanned: mode === 'empty' ? 0 : result.scanned,
    matched: mode === 'unavailable_markets' ? result.matched : 0,
    decision: null, source: 'preview', events: events(result.events),
  }]))
  return { ...catalog, rehearsal: mode, events: events(catalog.events), collection_results }
}
